function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.668 5.8H3.933V4.517a2.869 2.869 0 0 1 5.735 0v1.285zm-1.995 7.073a.874.874 0 0 1-1.748 0v-2.458a.874.874 0 0 1 1.748 0v2.458zM11.415 5.8V4.516a4.617 4.617 0 0 0-9.23 0v1.285A2.185 2.185 0 0 0 0 7.985v7.32a2.185 2.185 0 0 0 2.185 2.184h9.23a2.184 2.184 0 0 0 2.185-2.185V7.985a2.184 2.184 0 0 0-2.185-2.184z",
  fillRule: "evenodd"
});

var SvgLockIcon = function SvgLockIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "rgb(69, 80, 91)",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock-icon.727fd3b0.svg";
export { ForwardRef as ReactComponent };